import './Header.css'

import ShoppingCart from '@material-ui/icons/ShoppingCart'
import SearchIcon from '@material-ui/icons/Search'
import IndianFlag from '../images/flags.png'
import LocationIcon from '@material-ui/icons/Room'
import { Link } from 'react-router-dom'
import {auth} from "../Firebase"

import {useSelector} from 'react-redux'

function Header(){

  let basket =useSelector(state => state.basket);
  console.log(basket);
  
  let user =useSelector( state => state.user);
  const handleAuthentication=()=>{
    if(user){
        auth.signOut();

    }

}

    return(
    
      
      <div className='header'>
        <div className='row header__main'>
            <div className="col header__section1">   
               <Link to ="/" ><div className='header__logopart'>
                  <img className='header__logo' src='http://pngimg.com/uploads/amazon/amazon_PNG11.png' alt='amazon logo'/>
                </div></Link>

                <div className='header__location'>
            <LocationIcon className='header__LoactionIcon' style={{ fontSize: 35 }} />
           <div className='header__address' data-toggle="modal" data-target="#myModal">
              <span className='header__option1'>Hello</span>
              <span className='header__option2'>Select your address</span>
            </div>
          </div>
            </div>

            <div className="col header__section2">
              <div className="header__search">
                  <input type='text' placeholder="Search for Gadgets, Cloths, Electronic devices & Groceries etc" />
                  <div className="header__search1">
                  <SearchIcon></SearchIcon>
                  </div>
              </div>
            </div>


            <div className="col header__section3">
              <div className="header__country">
                  <img className="header__flag" src={IndianFlag}/>
              </div>

              <Link to ="/sign">  <div className="header__user" onClick={handleAuthentication} >
               
                 <span className='header__option1'>{user?"Welcome " + user.email.substring(0,6):"Hello"}</span>
                 <span className='header__option2'>{user?"Sign out":"Sign in"}</span>
              </div></Link>


              <Link to ="/myorder"><div className="header__orders">
                   <span className='header__option1' >Returns</span>
                   <span className='header__option2'>& Orders</span>
              </div></Link>

                <Link to ="/addtocart"> <div className="header__cart">
                <div className="header__carticon">
                  <ShoppingCart style={{ fontSize: 30 }}></ShoppingCart>
                </div>
               <div classname="cartflex">
               <span className="colorcart">{basket.length}</span> 
                  <span className="colorcart"><small>Cart</small></span>
               </div>
              </div></Link>
             

            


              
            </div>
        </div>
         






    
       <div class="modal" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">
      
       
        <div class="modal-header">
          <h4 class="modal-title"><strong>Choose your location</strong></h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        
        <div class="modal-body">
      
       

        <div class="card account__body mx-auto d-block">                
                <div class="card-body">
                    
                    <p className="smallfont">Select a delivery location to see product availability and delivery options</p>
                    <button type='button' className='btn account__button1 mx-auto d-block'>Create your Amazon account</button>
                    <p className="smallfont">or enter any Indian pin code</p>
                    <input type='text' className='account__textbox mx-auto d-block'/>
                    <br/>
                    <button className="apply">Apply</button>

                    
                </div>
            </div>

        </div>
        
        
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
        </div>
        
      </div>
      </div>
    </div>
   
       
         
          

                 
                


  </div>
    )
  }

  export default Header;